import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';

import moment from 'moment';

// The list endpoints are expected to return JSON arrays. If a backend returns
// something else (an error object, a wrapped payload, or an HTML page when the
// URL isn't actually the API), coerce to [] so react-table can't crash the app.
const asArray = (x) => Array.isArray(x) ? x : [];

// GeneratedLicenses state
const initialState = {
    request: '',
    expire_date: moment().add(3, 'M'),
    productCodes: [],
    license_types: [],
    licenseKey : '',
    licenseRequest: '',
    licenseHolder : '',
    fullName: '',
    email: '',
    companyName: '',
    computerId : '',
    allLicenses : [],
    decodedLicense : null,
    currentPage : 1,
    activeLicense : {
        licenseKey: '',
        licenseReq: '',
        machineId:''
    }
};

// Authentication state.
// Rehydrate isLoggedIn from the persisted token so a page refresh does not
// bounce an already-authenticated user back to the login screen.
const authInitialState = {
    username: 'Jon Doe',
    adminInfo: 0,
    isLoggedIn: !!localStorage.getItem('accessToken')
};


const licenseAccessInitialState = {
    allLicenses : []
};




const handleLicenseAccessActions = (state = licenseAccessInitialState, action) => {
    switch (action.type) {
        case 'STORE_LICENSE_ACCESS':
            return {
                ...state, allLicenses: asArray(action.payload.allLicenses)
            };
        default:
            return state
    }

}

const usersInitialState = {
    allUsers: [],
    emails: []
}


const handleUserActions = (state = usersInitialState, action) => {
    switch (action.type) {
        case 'STORE_USERS':
            return {
                ...state, allUsers: asArray(action.payload.allUsers)
            };
        case 'STORE_USER_EMAILS':
            return {
                ...state, emails: asArray(action.payload)
            }
                default:
            return state
    }

}




const handleAuthenticationActions = (state = authInitialState, action) => {
    switch (action.type) {
        case 'AUTH_USER':
            return {
                ...state,
                username: action.payload.username,
                isLoggedIn: true
            }
        case 'LOG_OUT': {
            return {
                ...state,
                isLoggedIn: false,
                adminInfo: 0
            }
        }

        case 'STORE_ADMIN_INFO': {
            return {
                ...state,
                adminInfo: action.payload.admin,
            }
        }


        default:
            return state
    }
    return state;
}


const handleLicenceActions = (state = initialState, action) => {
    // console.log(action);
    // console.log(state)
    switch (action.type) {
        case 'INIT_LICENSE_WIZARD':
            return {
                ...state, expire_date: action.payload.expire_date,
                license_types: action.payload.license_types,
                license_format: true,
                licenseRequest: action.payload.licenseRequest || '',
                fullName: action.payload.fullName || '',
                email: action.payload.email || '',
                companyName: action.payload.companyName || '',
                currentPage: 1

            }
        case 'UPDATE_PRODUCT_CODES': return {
            ...state,
            productCodes: action.payload
        }
        case 'TOGGLE_LICENSE_TYPES':
            return {
                ...state, license_format: !state.license_format
            }
        case 'STORE_LICENSES':
           return {
               ...state, allLicenses: asArray(action.payload.allLicenses)
           }
       case 'STORE_DECODED_LICENSE':
           return {
               ...state, decodedLicense: action.payload
           }
       case 'NEXT_LICENSE_PAGE':
           return {
               ...state, currentPage: state.currentPage + 1
           }
       case 'PREVIOUS_LICENSE_PAGE':
            return {
                ...state, currentPage: state.currentPage - 1
            }

       case 'UPDATE_EXPIRE_DATE':
            return {
                ...state,
                expire_date: action.payload
            }
        case 'UPDATE_ACTIVE_LICENSE_KEY':
            return {
                ...state,
                activeLicense : {
                    licenseKey: action.payload.licenseKey,
                    machineId: action.payload.machineId,
                    licenseReq: state.activeLicense.licenseReq
                }
            }
        case 'UPDATE_ACTIVE_LICENSE_REQ':
            return {
                ...state, activeLicense: {
                    licenseKey: state.activeLicense.licenseKey,
                    machineId: state.activeLicense.machineId,
                    licenseReq: action.payload.licenseReq
                }
            }

        case 'UPDATE_LICENSE_REQUEST':
            return {
                ...state,
                licenseKey: action.payload.licenseKey,
                licenseHolder: action.payload.licenseHolder,
                licenseRequest: action.payload.licenseRequest,
                computerId: action.payload.computerId,
                license_types: action.payload.license_types,
                expire_date: action.payload.expire_date,
                fullName: action.payload.fullName,
                email: action.payload.email,
                authEmail: action.payload.authEmail,
                companyName: action.payload.companyName,
                licenseFormat: action.payload.licenseFormat
            };
        default:
            return state

    }
};

const LicensePortalApp = combineReducers({
    license: handleLicenceActions,
    auth: handleAuthenticationActions,
    users: handleUserActions,
    licenseAccess: handleLicenseAccessActions,
    form: formReducer
});

export default LicensePortalApp;
